import React, {
 useState, useRef, useCallback, useEffect,
} from 'react';
import styled from 'styled-components';
import { Button, Modal, Toast } from '@roo/roo';
import { useHistory, Link } from 'react-router-dom';
import { getAuthUrl } from '@utils/config';
import { JudgeAgreement } from '@pages/declare/Agreement';
import { signUserAgreement, getConf, getApplyPeriodFlag } from '@assets/apis/base';
import { TimeLine } from '@utils/utils';
import { useQuery } from '@hooks/query';
import { useUserData } from '../UserData';
import { userLogout } from '../UserData/user';

const UserInfoDiv = styled.div`
  display: flex;
  min-width: 62px;
`;

export function UserAction() {
  const {
    mtUid, roleType, signJudge, load, applyFlag,
  } = useUserData();
  const [signJudgeState, setSignJudgeState] = useState(false);
  const [applyPeriodFlag, setApplyPeriodFlag] = useState(true);
  const query = useQuery();
  const history = useHistory();
  const { loginUrl } = getAuthUrl();
  const formType = query.get('formType');
  const [countdown, setCountdown] = useState(10);
  const [showJudgeAgreement, setShowJudgeAgreement] = useState(false);
  const timerRef = useRef(null);

  // 获取申报相关配置
  useEffect(() => {
    getApplyPeriodFlag()
      .then((res) => {
          setApplyPeriodFlag(res.applyPeriodFlag);
        })
      .catch(() => {
        // 接口错误时默认为在申报期内
        setApplyPeriodFlag(true);
      });
  }, []);

  const handleApply = useCallback(() => {
    getConf()
      .then((res) => {
        const { timestamp, projectConfDto } = res;
        const {
          sciStartTime, sciEndTime, inoStartTime, inoEndTime, earlyTime, lastTime,
        } = TimeLine(projectConfDto || [], timestamp);
        if (timestamp < earlyTime) return Toast.warning({ children: '敬请期待！' });
        if (timestamp > lastTime) return Toast.warning({ children: '申报已截止！' });
        const signSci = localStorage.getItem('signSci');
        const signIno = localStorage.getItem('signIno');
        if (signSci === 'true') {
          if (timestamp < sciStartTime) return Toast.warning({ children: '敬请期待！' });
          if (timestamp > sciEndTime) return Toast.warning({ children: '申报已截止！' });
          if (applyFlag) {
            return history.replace({
              pathname: '/preview',
              search: `formType=${formType || 'scientist'}`,
            });
          }
          return history.replace({ pathname: '/apply/scientist' });
        }

        if (signIno === 'true') {
          if (timestamp < inoStartTime) return Toast.warning({ children: '敬请期待！' });
          if (timestamp > inoEndTime) return Toast.warning({ children: '申报已截止！' });
          return history.replace({ pathname: '/apply/innovate' });
        }
        return history.replace({ pathname: '/declare' });
      })
      .catch((err) => {
        console.log(err);
        Toast.destroy();
        Toast.warning({ children: '服务开小差啦！' });
      });
  }, [applyFlag, formType, history]); // 依赖数组包含applyFlag

  const handleReview = () => {
    timerRef.current = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timerRef.current);
        }
        return prevCount - 1;
      });
    }, 1000);
    setShowJudgeAgreement(true);
  };

  if (!load) {
    // 用户信息接口没返回时不显示
    return <UserInfoDiv />;
  }

  if (mtUid && ['1', '2', '3'].includes(roleType)) {
    return (
      <UserInfoDiv className="h-u-info">
        <Button
          style={{ marginRight: 12 }}
          onClick={() => {
            userLogout();
          }}
        >
          退出
        </Button>
        {roleType !== '1' && (
          <Button>
            <div
              style={{ color: 'white' }}
              onClick={handleApply}
            >
              奖项申报
            </div>
          </Button>
        )}
        {roleType === '1'
          && (signJudge || signJudgeState ? (
            <Button>
              <Link to="/review" style={{ color: 'white' }}>
                评审入口
              </Link>
            </Button>
          ) : (
            <Button
              onClick={handleReview}
            >
              评审入口
              <Modal
                visible={showJudgeAgreement}
                title="评审专家公正性承诺书"
                closable={false}
                onConfirm={() => {
                  signUserAgreement({ type: 'judge' }).then(() => {
                    setTimeout(() => {
                      try {
                        window.location.href = '/review';
                      } catch (error) {
                        console.log(error);
                      }
                    }, 500);
                    setSignJudgeState(true);
                  });
                }}
                confirmText={countdown > 0 ? `阅读倒计时(${countdown}s)` : '同意，继续评审'}
                confirmButtonProps={{
                  disabled: countdown > 0,
                }}
                showCancelButton={false}
                onCancel={() => setShowJudgeAgreement(false)}
              >
                <JudgeAgreement />
              </Modal>
            </Button>
          ))}
      </UserInfoDiv>
    );
  }
  const handleNotInPeriod = () => {
    Toast.warning({ title: '当前不在奖项申报期' });
  };

  return (
    <UserInfoDiv>
      <Button
        onClick={() => {
          if (!applyPeriodFlag) {
            handleNotInPeriod();
            return;
          }
          window.location.href = loginUrl;
        }}
      >
        登录
      </Button>
      <Button
        className="award-apply-button"
        onClick={() => {
          if (!applyPeriodFlag) {
            handleNotInPeriod();
            return;
          }
          window.location.href = loginUrl;
        }}
      >
        奖项申报
      </Button>
    </UserInfoDiv>
  );
}
